angular
    .module('WizApp')
    .directive('homeDynamicRegisterOpener', [
        'EVENT_NAMES',
        '$rootScope',
        function (EVENT_NAMES, $rootScope) {
            return {
                restrict: 'A',
                scope: {
                    options: '<homeDynamicRegisterOpener'
                },
                link: function (scope, element) {
                    element.on('click', event => {
                        const options = {
                            cta: _.get(scope.options, 'login', false) ? 'login' : 'signup',
                            type: scope.options.type
                        };

                        $rootScope.$emit(EVENT_NAMES.homeDynamicRegisterLightbox.open, options);
                        scope.$apply();

                        event.stopPropagation();
                        event.preventDefault();
                    });
                }
            };
        }
    ]);
